module.exports = __webpack_public_path__ + "img/2017feilvbin.8f4d8d86.png";